var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDebitcardtransaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.283 3H2.71698C1.77 3 1 3.82183 1 4.83099V11.169C1 12.1789 1.77066 13 2.71698 13H13.283C14.23 13 15 12.1782 15 11.169V4.83099C15 3.82113 14.23 3 13.283 3ZM14 11.169C14 11.7127 13.7922 12 13.283 12H2.71698C2.20717 12 2 11.7127 2 11.169V7H14V11.169ZM14 6H2V4.83099C2 4.28732 2.20717 4 2.71698 4H13.283C13.7922 4 14 4.28732 14 4.83099V6ZM10.2453 10.4C10.2453 10.1662 10.4229 9.99859 10.6415 9.99859H11.9623C12.1809 9.99859 12.3585 10.1669 12.3585 10.4C12.3585 10.8751 12.1809 11 11.9623 11H10.6415C10.4229 11 10.2453 10.8888 10.2453 10.4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebitcardtransaction);
export default __webpack_public_path__ + "static/media/debit card transaction.0c1cf88c806ea5fd4bba997eb3d48760.svg";
export { ForwardRef as ReactComponent };